import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "iodine-scrollable-y browse-reference" }
const _hoisted_2 = { class: "row items-center browse-result-item iodine-padding-left-sm" }

import { ref, watch } from 'vue';
import { ReferencesArticle } from 'src/services/TrucodeReferencesService';
import { useTrucodeReferenceStore } from 'stores/TrucodeReferenceStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesBrowse',
  emits: ["articleChanged"],
  setup(__props, { emit: __emit }) {

const selected = ref(null)
const issueId = ref<number | undefined>(undefined)
const referenceArticles = ref<ReferencesArticle[]>([])

const emit = __emit

function onSelectionChanged(article: ReferencesArticle) {
  console.log(`Article: ${article.ArticleTitle} ID: ${article.ID}`);
  if (article.ID) {
    emit('articleChanged', article.ID);
  }
}

watch(() => issueId, async (newIssueId) => {
    if (newIssueId && newIssueId.value) {
      await useTrucodeReferenceStore().getReferencesArticles(newIssueId.value).then((result) => {
        referenceArticles.value = result?.Articles || [];
      });
    }
  },
  {immediate: true}
);

return (_ctx: any,_cache: any) => {
  const _component_q_tree = _resolveComponent("q-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_tree, {
      nodes: referenceArticles.value,
      "node-key": "id",
      "no-connectors": "",
      icon: "fa-solid fa-caret-right",
      class: "iodine-padding-left-lg",
      selected: selected.value,
      "onUpdate:selected": [
        _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
        onSelectionChanged
      ]
    }, {
      "default-header": _withCtx((prop) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(prop.node.label), 1)
        ])
      ]),
      _: 1
    }, 8, ["nodes", "selected"])
  ]))
}
}

})